module.exports = __webpack_public_path__ + "img/newsletter_icon_light.c1b78e3c.svg";